import React from "react";
import { func, object } from "prop-types";

import "./profileImage.m.css";

const ProfileImage = ({ member, onClick }) => {
  if (member["avatar-url"]) {
    return (
      <div styleName="profile-wrapper" onClick={onClick}>
        <img src={member["avatar-url"]} alt={member.name} styleName="profile-pic" />
      </div>
    );
  }

  return (
    <div styleName="profile-wrapper-circle" onClick={onClick}>
      <span styleName="profile-circle">{member.name.charAt(0)}</span>
    </div>
  );
};

ProfileImage.propTypes = {
  onClick: func,
  member: object,
};

export default ProfileImage;
